export const firebaseConfig = {
    apiKey: "AIzaSyA0e4AdqdQhmi7zVTA4x47_0RlXsyiniqM",
    authDomain: "neo-we-care.firebaseapp.com",
    databaseURL: "https://neo-we-care-default-rtdb.firebaseio.com",
    projectId: "neo-we-care",
    storageBucket: "neo-we-care.firebasestorage.app",
    messagingSenderId: "492603643135",
    appId: "1:492603643135:web:a9c4324141639a6988e8ca",
    measurementId: "G-7N99EQFZL3"
};